import React from "react";
import Icon from "components/AppIcon";
import Image from "components/AppImage";


const badgeConfig = {
  gold: { icon: "Medal", color: "#F59E0B", label: "Top Performer" },
  silver: { icon: "Award", color: "#94A3B8", label: "High Achiever" },
  bronze: { icon: "Star", color: "#CD7C2F", label: "Strong Performer" }
};

function formatRupees(value) {
  if (value >= 10000000) return `₹${(value / 10000000)?.toFixed(1)}Cr`;
  if (value >= 100000) return `₹${(value / 100000)?.toFixed(1)}L`;
  return `₹${value?.toLocaleString('en-IN')}`;
}

export default function RepLeaderboard({ reps: repsProp }) {
  const leaderboard = (repsProp || []).map((rep, index) => ({
    id: rep?.id || index + 1,
    name: rep.name,
    avatar: rep.avatar || null,
    avatarAlt: rep.avatarAlt || `${rep.name} profile image`,
    territory: rep.territory,
    quota: rep.quota,
    attained: rep.attained,
    deals: rep.deals,
    badge: rep.badge,
  }));

  const initials = (name) =>
    String(name || '?')
      .split(' ')
      .map((n) => n?.[0])
      .filter(Boolean)
      .slice(0, 2)
      .join('')
      .toUpperCase();

  return (
    <div
      className="card-base p-4 md:p-5 h-full flex flex-col"
      style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}>
      
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="font-heading font-semibold text-base" style={{ color: "var(--color-foreground)" }}>
            Rep Leaderboard
          </h3>
          <p className="text-xs font-caption mt-0.5" style={{ color: "var(--color-text-secondary)" }}>
            Ranked by closed-won revenue
          </p>
        </div>
        <Icon name="Trophy" size={18} color="var(--color-accent)" />
      </div>
      <div className="flex flex-col gap-3 flex-1">
        {leaderboard?.map((rep, idx) => {
          const pct = rep?.quota ? Math.round(rep?.attained / rep?.quota * 100) : null;
          const badge = rep?.badge ? badgeConfig?.[rep?.badge] : null;
          return (
            <div key={rep?.id} className="flex flex-col gap-1.5">
              <div className="flex items-center gap-2.5">
                <span
                  className="text-xs font-data font-bold w-5 text-center flex-shrink-0"
                  style={{ color: idx < 3 ? "var(--color-accent)" : "var(--color-text-secondary)" }}>
                  
                  {idx + 1}
                </span>
                <div className="w-8 h-8 rounded-full overflow-hidden flex-shrink-0"
                  style={{ background: "var(--color-muted)" }}>
                  {rep?.avatar ? (
                    <Image src={rep?.avatar} alt={rep?.avatarAlt} className="w-full h-full object-cover" />
                  ) : (
                    <span className="flex items-center justify-center w-full h-full text-xs font-bold font-caption"
                      style={{ color: "var(--color-text-secondary)" }}>
                      {initials(rep?.name)}
                    </span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-medium font-caption truncate" style={{ color: "var(--color-foreground)" }}>
                      {rep?.name}
                    </span>
                    {badge &&
                    <Icon name={badge?.icon} size={13} color={badge?.color} />
                    }
                  </div>
                  <span className="text-xs font-caption" style={{ color: "var(--color-text-secondary)" }}>
                    {rep?.territory} · {rep?.deals} deals
                  </span>
                </div>
                <span
                  className={`text-xs font-data font-bold flex-shrink-0 ${pct === null ? "" : pct >= 90 ? "text-emerald-600" : pct >= 70 ? "text-amber-600" : "text-red-500"}`}>
                  
                  {pct === null ? "—" : `${pct}%`}
                </span>
              </div>
              <div className="ml-7 flex items-center gap-2">
                <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ background: "var(--color-muted)" }}>
                  <div
                    className="h-full rounded-full transition-all duration-500"
                    style={{
                      width: pct === null ? "0%" : `${Math.min(pct, 100)}%`,
                      background: pct === null ? "transparent" : pct >= 90 ? "var(--color-success)" : pct >= 70 ? "var(--color-warning)" : "var(--color-error)"
                    }} />
                  
                </div>
                <span className="text-xs font-data flex-shrink-0" style={{ color: "var(--color-text-secondary)" }}>
                  {formatRupees(rep?.attained)}
                </span>
              </div>
            </div>);

        })}
      </div>
      <div className="mt-4 pt-3 border-t flex items-center justify-between" style={{ borderColor: "var(--color-border)" }}>
        <span className="text-xs font-caption" style={{ color: "var(--color-text-secondary)" }}>
          Total closed-won
        </span>
        <span className="text-sm font-data font-bold" style={{ color: "var(--color-primary)" }}>
          {leaderboard?.length
            ? formatRupees(leaderboard.reduce((acc, rep) => acc + (rep.attained || 0), 0))
            : "-"}
        </span>
      </div>
    </div>);

}